module.exports = __webpack_public_path__ + "img/曲阳石雕.358c0d28.jpg";